export const min1024pxWideMediaQuery = () =>
  window.matchMedia('only screen and (min-width: 1024px)');
export const isMin1024pxWide = () => min1024pxWideMediaQuery().matches;

export const isMin768pxWideMediaQuery = () =>
  window.matchMedia('only screen and (min-width: 768px)');
export const isMin768pxWide = () => isMin768pxWideMediaQuery().matches;

export const touchMediaQuery = () => window.matchMedia('(pointer: coarse)');
export const isTouchDevice = () => touchMediaQuery().matches;

const tabletPortraitMediaQuery = () =>
  window.matchMedia(
    'only screen and (min-width: 768px) and (max-width: 1023px) and (pointer: coarse)'
  );
export const isTabletPortrait = () => tabletPortraitMediaQuery().matches;

export const addMediaQueryListener = callback => {
  const mediaQuery = tabletPortraitMediaQuery();

  const handler = e => {
    if (e.matches === false) {
      callback();
    }
  };

  // Check if addEventListener is supported (modern browsers)
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', handler, { once: true });

    return () => {
      mediaQuery.removeEventListener('change', handler);
    };
  } else {
    // Fallback for Safari 13 and older browsers
    const onceHandler = e => {
      handler(e);
      mediaQuery.removeListener(onceHandler);
    };

    mediaQuery.addListener(onceHandler);

    return () => {
      mediaQuery.removeListener(onceHandler);
    };
  }
};
